import React, { useEffect, useState } from 'react'

interface CartRecommendedSelectProps {
    product: {
        title: string,
        variants: [{
          id: number
        }],
        id: string | number,
        price: string | number,
        // eslint-disable-next-line camelcase
        featured_image: string,
        // eslint-disable-next-line camelcase
        options: [string]
    }
}

const CartRecommendedSelect = (props: CartRecommendedSelectProps): JSX.Element => {
  const { product } = props
  const [optString, setOptString] = useState('');
  const optionDeterminer = (): void => {
    if(!product.options[0]) {
      setOptString(window['theme'].strings.cartRecsOpts)
    } else {
      setOptString(product.options[0]['name'])
    }
  }

  useEffect(() => {
    optionDeterminer()
  }, [product])

  const handleSelectChange = (e:React.ChangeEvent<HTMLSelectElement>) => {
 
    const selector = e.target;
    const selectedOption = selector.options[e.target.selectedIndex]
    const parent = document.querySelector(`[data-upsell-item="${e.target.dataset.upsellOptionSelector}"]`);
    const atcButton = parent.querySelector('[data-add-to-cart-with-variant]');
    const { variantAvailable} = selectedOption.dataset;
 
    if (!selectedOption.value) {
      atcButton.setAttribute('disabled', 'disabled');
    } else {
      atcButton.setAttribute('data-atc-product-id', selectedOption.value);

      if (variantAvailable === 'true') {
        atcButton.textContent = atcButton.getAttribute('data-atc-text');
        atcButton.removeAttribute('disabled');
      } else {
        atcButton.textContent = atcButton.getAttribute('data-atc-oos-text');
        atcButton.setAttribute('disabled', 'disabled');
      }
    }
  }   

  let selectMarkUp: JSX.Element;

  if(product.variants.length > 1) {
    selectMarkUp = <> <div className="select-wrapper">
      <label htmlFor={`product-options-${product.id}`} className="visually-hidden">{optString}</label>
      <select data-upsell-option-selector={product.id} name="id" id={`product-options-${product.id}`} defaultValue={optString} className="select" onChange={e => handleSelectChange(e)}>
        <option          
          value={optString}
          disabled
        >{optString}
        </option>
        {product.variants.map(variant => {
          return (
            <option
              key={variant['id']}
              value={variant['id']}
              data-variant-available={variant['available']}
            >
              {variant['available'] ? variant['title'] : window['theme'].strings.soldOut}
            </option>
          )
        })}
      </select>
    </div> 

    <button
      disabled
      type="submit"
      className="btn btn-primary"
      data-aid="product-upsell-atc"
      data-add-to-cart-with-variant
      data-atc-quantity-input={`#upsell-quantity-${product['handle']}`}
      data-atc-product-id={product.id}
      data-atc-text={window['theme'].strings.addToCart}
      data-atc-oos-text={window['theme'].strings.soldOut}
    >{window['theme'].strings.select} {optString}</button>
    </> 
  } else {
    selectMarkUp = <>
      <input type="hidden" name="id" value={product.variants[0].id}></input>
      <button
        disabled={!product['available']}
        type="submit"
        className="btn btn-primary"
        data-aid="product-upsell-atc"
        data-add-to-cart-with-variant
        data-atc-quantity-input={`#upsell-quantity-${product['handle']}`}
        data-atc-product-id={product.variants[0].id}
        data-atc-text={window['theme'].strings.addToCart}
        data-atc-oos-text={window['theme'].strings.soldOut}
      >{product['available'] ? window['theme'].strings.addToCart : window['theme'].soldOut }</button>
    </>
  }
  
  return (
    <div>
      <form action="/cart/add">
        <input type="hidden" name="form_type" value="product"></input>
        <input type="hidden" name="utf8" value="✓"></input>
        <input type="hidden" value="1" id={`upsell-quantity-${product.title}`} name="quantity"></input>
        {selectMarkUp}
      </form>
    </div>
  )
}

export default CartRecommendedSelect
